import { TableHead as MaterialTableHead, TableRow } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { Sort } from "../../services/pageable";
import { colours } from "../../styles/colours";
import { StyledTable } from "./base";

export type TableHeaders<K> = Array<{
  name: K;
  title: string;
  centered?: boolean;
  hiddenMobile?: boolean;
}>;

export const HeadRow = styled(TableRow)`
  vertical-align: bottom;
  color: ${colours.blueGrey};
`;

export type TableHeadProps<K extends PropertyKey, UnsortableField extends K> = {
  fields: TableHeaders<K>;
  sort?: Sort<Exclude<K, UnsortableField>>;
  onSortChange?: (s: Sort<Exclude<K, UnsortableField>>) => void;
  unsortable: Array<UnsortableField>;
};

const DirectionSpan = styled.span`
  border: 0;
  clip: "rect(0 0 0 0)";
  height: 1;
  margin: -1;
  overflow: "hidden";
  padding: 0;
  position: "absolute";
  top: 20;
  width: 1;
`;

function isSortableField<
  All extends PropertyKey,
  Unsorted extends All,
  K extends Exclude<All, Unsorted>
>(unsortable: Array<Unsorted>, field: All): field is K {
  return !unsortable.find((f) => f === field);
}

export function TableHead<
  Field extends PropertyKey,
  UnsortableField extends Field
>({
  fields,
  sort,
  onSortChange,
  unsortable,
}: TableHeadProps<Field, UnsortableField>) {
  return (
    <MaterialTableHead>
      <HeadRow>
        {fields.map(({ name, title, centered, hiddenMobile }, index) => (
          <StyledTable.Cell
            key={name.toString()}
            noPadding
            align={centered ? "center" : "left"}
            hiddenMobile={hiddenMobile}
          >
            {isSortableField(unsortable, name) ? (
              <StyledTable.StyledSortLabel
                active={sort?.field === name}
                direction={sort?.direction}
                onClick={() =>
                  onSortChange &&
                  onSortChange({
                    field: name,
                    direction: sort?.direction === "asc" ? "desc" : "asc",
                  })
                }
              >
                {title}
                {sort?.field === name ? <DirectionSpan></DirectionSpan> : null}
              </StyledTable.StyledSortLabel>
            ) : (
              <StyledTable.StyledLabel>{title}</StyledTable.StyledLabel>
            )}
          </StyledTable.Cell>
        ))}
      </HeadRow>
    </MaterialTableHead>
  );
}
